/**
 * Legacy audit rows use parallel arrays under `data.updated_at`.
 * Tripletex / hour sync rows use a plain JSON object in `data`.
 */
export function isBatchHistoryDataShape(parsed) {
  return (
    parsed &&
    typeof parsed === "object" &&
    !Array.isArray(parsed) &&
    Array.isArray(parsed.updated_at)
  );
}

/**
 * API normally returns `changes` as an object. Older payloads may be JSON strings or `_legacy` wrapper keys.
 */
export function parseHistoryChanges(raw) {
  if (raw == null || raw === "") return {};
  if (typeof raw === "object" && !Array.isArray(raw)) return raw;
  if (typeof raw === "string") {
    const s = raw.trim();
    if (!s) return {};
    try {
      return JSON.parse(s);
    } catch {
      return { _legacy: raw };
    }
  }
  return {};
}
